import React, { useContext, useEffect } from 'react'
import {
  BrowserRouter,
  Outlet,
  Route,
  Routes,
  useParams,
} from 'react-router-dom'

import { LandingPage } from '@resurs-internal/styx-react-templates'

import { Auth } from './Auth/Auth'
import Content from './Content'
import { Sign } from './Sign/Sign'
import { StoreEvents } from './Events/StoreEvents'
import './App.scss'
import {
  PageContext,
  PageContextProvider,
} from './TestPage/Editor/ContentContext'
import { EditPagesRoute } from './TestPage/Editor/EditPagesRoute'
import { CheckpointMockSigning } from './Mock/CheckpointMockSigning'
import { CheckpointMockAuthentication } from './Mock/CheckpointMockAuthentication'
import { CheckpointBankIdMock } from './Mock/CheckpointBankIdMock'
import { DigitalIdMockAuthentication } from './Mock/DigitalIdMockAuthentication'
import { DigitalIdMockSigning } from './Mock/DigitalIdMockSigning'
import { CwaConsent } from './Mock/CwaConsent'
import { EskatConsent } from './Mock/EskatConsent'
import { ExperianConsent } from './Mock/ExperianConsent'
import { SblConsent } from './Mock/SblConsent'
import { MockSign } from './Mock/MockSign'
import { MockAuthentication } from './Mock/MockAuthentication'
import { OpenBankingMock } from './Mock/OpenBankingMock'

const Layout = () => (
  <LandingPage>
    <Content.Center>
      <p className="devStamp">TEST</p>
      <Outlet />
    </Content.Center>
  </LandingPage>
)

const Index = () => <p>Not found</p>

const MockDoCheckpointAction = () => {
  const { cprPath } = useParams()

  useEffect(() => {
    window.location.href = `${process.env.REACT_APP_CHECKPOINT_MOCK_PROXY_PATH}/mock/${cprPath}${window.location.search}`
  }, [])

  return null
}

const App = () => {
  const { pages } = useContext(PageContext)

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route exact path="/mock/sign" element={<Sign />} />
          <Route exact path="/mock/authenticate" element={<Auth />} />
          <Route
            exact
            path="/mock/:cprPath"
            element={<MockDoCheckpointAction />}
          />
          <Route
            exact
            path="/events/store/:storeId"
            element={<StoreEvents />}
          />

          {/* retail-finance-mock pages */}
          <Route
            path="/mock/signing/:token"
            element={<CheckpointMockSigning />}
          />
          <Route
            path="/mock/authentication/:token"
            element={<CheckpointMockAuthentication />}
          />
          <Route
            path="/mock/bankid/:token"
            element={<CheckpointBankIdMock />}
          />
          <Route
            path="/mock/digital-id/authentication/:token"
            element={<DigitalIdMockAuthentication />}
          />
          <Route
            path="/mock/digital-id/signing/:token"
            element={<DigitalIdMockSigning />}
          />
          <Route path="/mock/cwa-consent/:token" element={<CwaConsent />} />
          <Route path="/mock/eskat-consent/:token" element={<EskatConsent />} />
          <Route
            path="/mock/experian-consent/:token"
            element={<ExperianConsent />}
          />
          <Route path="/mock/sbl-consent/:token" element={<SblConsent />} />
          <Route path="/mock/rfm/sign/:token" element={<MockSign />} />
          <Route
            path="/mock/rfm/authenticate/:token"
            element={<MockAuthentication />}
          />
          <Route
            path="/mock/open-banking/:sessionId"
            element={<OpenBankingMock />}
          />
          <Route path="/mock/open-banking" element={<OpenBankingMock />} />

          <Route index element={<Index />} />
          <Route path="*" element={<Index />} />
        </Route>

        <Route
          path="/test/*"
          element={
            <PageContextProvider>
              <Routes>
                <Route
                  path="/edit"
                  element={<EditPagesRoute pages={pages} />}
                />
              </Routes>
            </PageContextProvider>
          }
        />
      </Routes>
    </BrowserRouter>
  )
}

export default App
